module.exports = __webpack_public_path__ + "img/new_lo_background.851d0840.png";